// import React from "react";
// import s1 from "../assets/s1.png";
// import bill1 from "../assets/bill1.png";
// import bill2 from "../assets/bill2.png";
// import bill3 from "../assets/bill3.png";
// import bill4 from "../assets/bill4.png";
// import bill5 from "../assets/bill5.png";
// import bill6 from "../assets/bill6.png";
// import v14 from "../assets/Vector 14.png";
// import hi1 from "../assets/hi1.png";
// import hi2 from "../assets/hi2.png";
// import hi3 from "../assets/hi3.png";
// import v from "../assets/Vs.png";
// import PhoneHeader from "./PhoneHeader";

// const BBPSService = () => {
//   const steps = [
//     {
//       img: hi1,
//       text: "Customers provide the biller details and their bill information.",
//     },
//     {
//       img: hi2,
//       text: "The platform fetches bill data and displays outstanding amount.",
//     },
//     {
//       img: hi3,
//       text: "Customers pay via their preferred method; an electronic receipt is generated.",
//     },
//   ];

//   const data = [
//     {
//       title: "Financial Inclusion",
//       text: "Brings banking to remote or rural areas without branches.",
//     },
//     {
//       title: "Secure & Reliable",
//       text: "Uses Aadhaar authentication, reducing fraud risk.",
//     },
//     {
//       title: "No Card Required",
//       text: "Works without debit/credit cards or smartphones in some cases.",
//     },
//     {
//       title: "Commission for Agents",
//       text: "Agents / BCs can earn commission on each transaction.",
//     },
//   ];
//   return (
//     <>
//     <PhoneHeader title="BBPS Service" className="d-md-none d-block" />
//       <div className="container-fluid d-md-block d-none">
//         <div className="text-center top-heading section">
//           <h1>BBPS Service</h1>
//         </div>
//       </div>
//       <div className="container">
//         <div className="row section align-items-center">
//           <div className="col-12 col-md-6 mb-3 mb-md-0">
//             <h1>
//               <strong>Overview</strong>
//             </h1>
//           </div>

//           <div className="col-12 col-md-6">
//             <p>
//               <strong style={{ color: "#FF7A60", fontSize: "26px" }}>O</strong>
//               ur platform supports digital payments via UPI along with cash
//               access through Micro ATMs — giving customers flexibility to go
//               cashless or withdraw cash conveniently. Based on PaymentHub’s
//               service model
//             </p>
//           </div>
//         </div>

//         <div className="section">
//           <img src={s1} className="w-100" />
//         </div>

//         <div className="row section key-features text-center">
//           <div className="col-12">
//             <h2 className="text-center mb-5" style={{ fontWeight: "700" }}>
//               Supported Bill Categories
//             </h2>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill1} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>Electricity</p>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill2} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>Gas</p>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill3} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>DTH / Cable</p>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill4} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>Water</p>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill5} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>Broadband / Telecom</p>
//           </div>

//           <div className="col-6 col-md-2 mb-4">
//             <img src={bill6} className="bill-icon mb-2" />
//             <p style={{ fontWeight: "600" }}>
//               Other recurring utility services
//             </p>
//           </div>
//         </div>

//         <div className="steps-container d-md-block d-none section">
//           <div className="my-4">
//             <h2 style={{ fontWeight: "700" }}>How It Works</h2>
//           </div>

//           <img src={v14} className="wave-image my-5" alt="wave" />

//           {/* Step 1 */}
//           <div className="step-box steps-1">
//             <img src={hi1} className="icon" />
//             <p>
//               Customers provide the biller details and their bill information.
//             </p>
//           </div>

//           {/* Step 2 */}
//           <div className="step-box steps-2">
//             <p>
//               The platform fetches bill data and displays outstanding amount.
//             </p>
//             <img src={hi2} className="icon" />
//           </div>

//           {/* Step 3 */}
//           <div className="step-box steps-3">
//             <img src={hi3} className="icon" />
//             <p>
//               Customers pay via their preferred method; an electronic receipt is
//               generated.
//             </p>
//           </div>
//         </div>

//         <div className="mobile-steps d-block d-md-none section">
//           <h2 className="fw-bold mb-4 text-center">How It Works</h2>

//           <div className="mobile-steps-wrappers center">
//             <img src={v} className=" my-5" alt="wave" />

//             {/* Step 1 */}
//             <div className="step-box steps-1">
//               <p>
//                 Customers provide the biller details and their bill information.
//               </p>
//               <img src={hi1} className="icon" />
//             </div>

//             {/* Step 2 */}
//             <div className="step-box steps-2">
//               <img src={hi2} className="icon" />
//               <p>
//                 The platform fetches bill data and displays outstanding amount.
//               </p>
//             </div>

//             {/* Step 3 */}
//             <div className="step-box steps-3">
//               <p>
//                 Customers pay via their preferred method; an electronic receipt
//                 is generated.
//               </p>
//               <img src={hi3} className="icon" />
//             </div>
//           </div>
//         </div>

//         {/* benefits */}
//         <div className="section d-none d-md-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="benefits-wrapper position-relative">
//             <div className="benefit"></div>
//             <div className="center-line"></div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Convenience for Customers
//                   </h5>
//                   <p className="text-start">
//                     One-stop bill payment portal for multiple services.{" "}
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">Reliable & Secure</h5>
//                   <p>Backed by established payment network.</p>
//                 </div>
//               </div>
//             </div>

//             <div className="row align-items-center mb-5">
//               <div className="col-6 text-end">
//                 <div className="benefit-card">
//                   <h5 className="fw-bold text-start mb-3">
//                     Commission for Agents
//                   </h5>
//                   <p className="text-start">
//                     Agents can facilitate bill payments and earn fees. (Modelled
//                     like PaymentHub)
//                   </p>
//                 </div>
//               </div>
//               <div className="col-6"></div>
//             </div>

//             <div className="row align-items-center">
//               <div className="col-6"></div>
//               <div className="col-6">
//                 <div className="benefit-card-1">
//                   <h5 className="fw-bold mb-3">Digital Record</h5>
//                   <p>Customers get a digital bill receipt.</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="section d-md-none d-block">
//           <h2 className="text-center fw-bold mb-5">Benefits</h2>

//           <div className="row justify-content-center">
//             {data.map((item, index) => (
//               <div className="col-12 mb-3" key={index}>
//                 <div className="benefit-box text-center p-4">
//                   <h5 className="mb-2" style={{ fontWeight: "700" }}>
//                     {item.title}
//                   </h5>
//                   <p className="mb-0">{item.text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BBPSService;
import React from "react";
import s1 from "../assets/s1.png";
import solution from "../assets/solution.png";
import solution1 from "../assets/exchange.png";
import solution2 from "../assets/neural.png";
import solution3 from "../assets/cash-withdrawal.png";
import solution4 from "../assets/files.png";
import solution5 from "../assets/shield.png";
import PhoneHeader from "./PhoneHeader";
import benfits from "../assets/benfites.jpg";

const BBPSService = () => {
  return (
    <>
      <PhoneHeader title="AEPS Service" className="d-md-none d-block" />

      {/* <div className="container-fluid d-md-block d-none">
        <div className="text-center top-heading section">
          <h1>AEPS Service</h1>
        </div>
      </div> */}
      <div className="container space">
        <div className="text-center top-heading section">
          <h1>BBPS Services</h1>
        </div>
        <div className="row section align-items-center">
          <div className="col-12 col-md-7">
            <div className="">
              <h1>
                <strong>Overview</strong>
              </h1>
            </div>
            <p>
              {/* <strong style={{ color: "#FF7A60", fontSize: "26px" }}>B</strong> */}
              Bharat Bill Payment System (BBPS) is a centralized and
              interoperable platform launched by the National Payments
              Corporation of India (NPCI) to provide secure, fast, and
              convenient bill payment services across the country. Integrated
              with our platform and other digital payment modes, BBPS simplifies
              the way customers pay their everyday bills.
            </p>
            <ul className="list-unstyled mb-4 mb-md-0">
              <li className="fw-bold mb-2">
                • RBI-authorized and NPCI-backed BBPS platform
              </li>
              <li className="fw-bold mb-2">
                • One-stop solution for all bill payments
              </li>
              <li className="fw-bold mb-2">
                • Secure and trusted payment ecosystem
              </li>
              <li className="fw-bold mb-2">
                • Real-time bill fetch and instant confirmation
              </li>
              <li className="fw-bold mb-2">
                • Supports online and assisted bill payments
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-5 mb-3 mb-md-0">
            <div className="">
              <img src={s1} className="w-100 m-auto img-holl" />
            </div>
          </div>
        </div>

        <div className="section p-md-4 px-1 pt-5 pb-4" style={{ backgroundColor: "#FFF6F3" }}>
          <div className="container">
            <div className="row align-items-center">
              {/* Image Column */}
              <div className="col-12 col-lg-6 text-center mb-4 mb-lg-0 d-none d-md-block ">
                <img src={solution} alt="BBPS Solution" className="img-fluid" />
              </div>

              {/* Content Column */}
              <div className="col-12 col-lg-6">
                <h2 className="fw-bold mb-4 text-center text-lg-start">
                  Features of Our BBPS Services
                </h2>

                {/* Feature 1 */}
                <div className="d-flex mb-4 solution-icon gap-3">
                  <div className="solution-icon-wrapper">
                    <img src={solution5} alt="" className="img-fluid" />
                  </div>
                  <div>
                    <h6 className="fw-bold">All-in-One Bill Payments</h6>
                    <p className="mb-0">
                      Users can pay electricity, water, gas, DTH, broadband,
                      mobile postpaid, FASTag recharge, insurance premiums, loan
                      EMIs, and many more bills from a single platform.
                    </p>
                  </div>
                </div>

                {/* Feature 2 */}
                <div className="d-flex mb-4 solution-icon gap-3">
                  <div className="solution-icon-wrapper">
                    <img src={solution1} alt="" className="img-fluid" />
                  </div>
                  <div>
                    <h6 className="fw-bold">Secure & Reliable</h6>
                    <p className="mb-0">
                      Backed by NPCI, BBPS ensures high security standards,
                      real-time confirmation, and hassle-free transactions.
                    </p>
                  </div>
                </div>

                {/* Feature 3 */}
                <div className="d-flex mb-4 solution-icon gap-3">
                  <div className="solution-icon-wrapper">
                    <img src={solution2} alt="" className="img-fluid" />
                  </div>
                  <div>
                    <h6 className="fw-bold">24/7 Availability</h6>
                    <p className="mb-0">
                      Customers can make bill payments anytime, anywhere, even
                      on holidays.
                    </p>
                  </div>
                </div>

                {/* Feature 4 */}
                <div className="d-flex mb-4 solution-icon gap-3">
                  <div className="solution-icon-wrapper">
                    <img src={solution3} alt="" className="img-fluid" />
                  </div>
                  <div>
                    <h6 className="fw-bold">Instant Confirmation</h6>
                    <p className="mb-0">
                      Every successful transaction generates an instant receipt,
                      giving customers peace of mind.
                    </p>
                  </div>
                </div>

                {/* Feature 5 */}
                <div className="d-flex solution-icon">
                  <div className="solution-icon-wrapper">
                    <img src={solution4} alt="" className="img-fluid" />
                  </div>
                  <div>
                    <h6 className="fw-bold">Multiple Payment Options</h6>
                    <p className="mb-0">
                      BBPS supports AEPS, UPI, debit cards, wallets, net
                      banking, and cash (via agent outlets).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4 section">
          <h2
            className="mt-md-4 mb-md-5"
            style={{ textAlign: "center", fontWeight: "600" }}
          >
            Our BBPS Bill Payment Service
          </h2>
          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Electricity Bill Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Pay electricity bills of major state and private power
                distribution companies instantly with real-time confirmation.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Water Bill Payment </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Quick and hassle-free water bill payments for supported
                municipal and private water boards.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Gas Bill Payment</h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Pay piped gas bills easily without standing in long queues.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so1}
                alt="Software Development"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Mobile Postpaid Bill Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Instant payment for all major mobile postpaid operators with
                receipt confirmation.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so2}
                alt="Hardware Support"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Landline & Broadband Bill Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Pay landline, broadband, and internet bills for leading service
                providers under one platform.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                DTH Recharge & Bill Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Recharge or pay monthly bills for all major DTH operators
                quickly and securely.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4 rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#FFDED3" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Insurance Premium Payment
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Pay life and general insurance premiums on time through trusted
                BBPS channels.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#EBF4E7" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">Loan EMI Payment</h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Convenient repayment of loan EMIs for supported banks and NBFCs.
              </p>
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-4 d-flex">
            <div
              className="p-4  rounded-4 w-100 d-flex flex-column"
              style={{ backgroundColor: "#E0FBFF" }}
            >
              {/* <img
                src={so3}
                alt="Network & Maintenance"
                className="mb-3 img-fluid"
              /> */}
              <h5 className="fw-semibold text-center">
                Municipal & Other Utility Bills
              </h5>
              <p className="mt-2 flex-grow-1 text-center text-md-start mb-0">
                Pay municipal taxes and other approved utility bills available
                on BBPS.
              </p>
            </div>
          </div>
        </div>

        <div className="section key-features align-items-center py-md-5 p-4">
          {/* HEADING */}
          <h2 className="fw-bold text-center mb-4">
            Benefits for Retailers / Distributors
          </h2>

          <div className="row">
            {/* IMAGE */}
            <div className="col-12 col-md-5  text-center mb-4 mb-md-0">
              <img
                src={benfits}
                alt="Key Features"
                className="img-fluid img-holl"
                style={{ maxWidth: "100%" , width: "100%"}}
              />
            </div>

            {/* FEATURE LIST */}
            <div className="col-12 col-md-7 m-auto">
              <ul className="list-unstyled mx-auto">
                <li className=" mb-3">
                  • Earn attractive commissions on every bill payment
                </li>
                <li className=" mb-3">
                  • Provide a wide range of biller categories
                </li>
                <li className=" mb-3">
                  • Increase customer trust and engagement
                </li>
                <li className=" mb-3">
                  • Expand digital financial services in rural and semi-urban
                  areas
                </li>
                <li className="">
                  • Grow your business with a complete digital payment ecosystem
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BBPSService;
